var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.537,
    cy: 8.537,
    r: 6.082,
    transform: "rotate(37.953 9.537 8.537)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.815 13.294 1.42 18.94",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
export default SvgIconSearch;